/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_83ca495c"]'><div :class='["radio-demo"]'><view-desc>正常选项: {{ radioValue }}</view-desc><div :class='["cube-radio-demos"]'><cube-radio :option="(radio1)" :value="radioValue" mpxModelEvent="input" @mpxModel='(e)=>__invoke(e, [["__model","radioValue", "__mpx_event__", ["value"], undefined]])'>Option1</cube-radio><cube-radio :option="(radio2)" :value="radioValue" mpxModelEvent="input" @mpxModel='(e)=>__invoke(e, [["__model","radioValue", "__mpx_event__", ["value"], undefined]])'>Option2</cube-radio></div></div></div></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"mid":"_83ca495c"}'>
// .radio-demo
//   .cube-radio-demo-style
//     padding 5px 10px
//     box-sizing border-box
//     background-color #fff
//   .desc
//     margin-top 15px
</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_83ca495c"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_83ca495c"}
  /** script content **/
  require("./radio.mpx.js?isComponent&outputPath=components%2Fradio83ca495c%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./radio.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fradio83ca495c%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_83ca495c"],
    ctorType: "component",
    outputPath: "components/radio83ca495c/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'view-desc':getComponent(require("../../components/desc/index.mpx?isComponent&outputPath=components%2Findex590d50a3%2Findex")),'cube-radio':getComponent(require("../../../packages/mpx-cube-ui/src/components/radio/index.mpx?isComponent&outputPath=components%2Findex4aa5b228%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>